import { addDays, daysBetween, isValidIsoDate } from "../../lib/date/isoDate";
import { CATEGORY_RULES } from "./categories";
import type { FoodCategory, FoodItem, StorageLocation } from "./types";

/**
 * Estimates when an item stops being good: purchase date plus the shelf life
 * for its category and location.
 */
export function estimateExpiryDate(
  category: FoodCategory,
  location: StorageLocation,
  purchaseDate: string
): string {
  if (!isValidIsoDate(purchaseDate)) {
    throw new Error(`estimateExpiryDate: invalid purchaseDate "${purchaseDate}"`);
  }

  return addDays(purchaseDate, CATEGORY_RULES[category].shelfLifeDays[location]);
}

/** The date that actually governs an item: the user's own date wins if set. */
export function effectiveExpiryDate(item: FoodItem): string {
  return item.userExpiryOverride ?? item.estimatedExpiryDate;
}

/** Days until the item expires, relative to `today`. Negative means it already has. */
export function daysUntilExpiry(item: FoodItem, today: string): number {
  return daysBetween(today, effectiveExpiryDate(item));
}
